import { SearchIndex } from './search-index';

export interface SearchMatcher {
  matches(index: SearchIndex, normalizedQuery: string): boolean;
}

export const defaultSearchMatcher: SearchMatcher = {
  matches(index: SearchIndex, normalizedQuery: string): boolean {
    return (
      index.primary.includes(normalizedQuery) ||
      (index.secondary?.some((value) => value.includes(normalizedQuery)) ??
        false)
    );
  },
};
